import React, { useState } from 'react';
import TopNavbar from '../../components/TopNavBar/TopNavBar';
import AdminPortalSideBar from '../../containers/AdminSideBarContainer/AdminSideBarContainer';
import PaymentRequestDashboard from '../../containers/PaymentRequestDashboard/PaymentRequestDashboard';
import { PageContainer, ContentContainer } from './PaymentRequestPage.styles';

export default function PaymentRequestPage() {
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <>
      <TopNavbar onTabChange={setTabIndex} />
      <PageContainer>
        <AdminPortalSideBar />
        <ContentContainer>
          <PaymentRequestDashboard />
        </ContentContainer>
      </PageContainer>
    </>
  );
}
